import { useEffect, useState } from 'react';

function Callback() {
  const [status, setStatus] = useState('Processing login...');
  const [error, setError] = useState(null);

  useEffect(() => {
    const processLogin = async () => {
      // Check for tokens in URL hash (implicit flow)
      const hashParams = new URLSearchParams(window.location.hash.replace('#', ''));
      const accessTokenFromHash = hashParams.get('access_token');
      const idTokenFromHash = hashParams.get('id_token');

      console.log('=== Cognito Callback ===');
      console.log('URL:', window.location.href);
      console.log('Hash:', window.location.hash);
      console.log('Search:', window.location.search);

      // Handle implicit flow - tokens in URL hash
      if (accessTokenFromHash) {
        console.log('✅ Tokens from implicit flow!');
        storeTokens(accessTokenFromHash, idTokenFromHash);
        setStatus('✅ Bearer token received! Redirecting...');
        redirectToAdmin();
        return;
      }

      // Handle code flow - need to exchange code for tokens
      const code = new URLSearchParams(window.location.search).get('code');
      if (code) {
        console.log('Authorization code received:', code);
        setStatus('Exchanging code for tokens...');

        try {
          // Exchange code for tokens
          const tokens = await exchangeCodeForTokens(code);
          if (tokens && tokens.access_token) {
            console.log('✅ Tokens received from code exchange!');
            storeTokens(tokens.access_token, tokens.id_token);
            setStatus('✅ Bearer token received! Redirecting...');
            redirectToAdmin();
          } else {
            throw new Error('No access_token in response');
          }
        } catch (err) {
          console.error('Token exchange failed:', err);
          setError(err.message);
          setStatus('Token exchange failed. Storing code only...');
          localStorage.setItem('authCode', code);
          localStorage.setItem('isAdmin', 'true');
          setTimeout(() => redirectToAdmin(), 2000);
        }
        return;
      }

      setStatus('No authentication data found');
      setError('No code or token in URL');
    };

    // Function to exchange authorization code for tokens
    const exchangeCodeForTokens = async (code) => {
      const domain = process.env.REACT_APP_COGNITO_DOMAIN;
      const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
      const redirectUri = process.env.REACT_APP_COGNITO_REDIRECT_URI || (window.location.origin + '/callback');
      const tokenEndpoint = `${domain}/oauth2/token`;

      const params = new URLSearchParams();
      params.append('grant_type', 'authorization_code');
      params.append('client_id', clientId);
      params.append('code', code);
      params.append('redirect_uri', redirectUri);

      console.log('Calling token endpoint:', tokenEndpoint);

      const response = await fetch(tokenEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params,
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Token endpoint error:', errorText);
        throw new Error(`Token exchange failed: ${response.status} - ${errorText}`);
      }

      const tokens = await response.json();
      console.log('Token response:', tokens);
      return tokens;
    };

    // Function to store tokens
    const storeTokens = (accessToken, idToken) => {
      localStorage.setItem('accessToken', accessToken);
      if (idToken) localStorage.setItem('idToken', idToken);
      localStorage.setItem('tokenType', 'Bearer');
      localStorage.setItem('tokenTimestamp', Date.now().toString());
      localStorage.setItem('expiresIn', '3600');
      localStorage.setItem('isAdmin', 'true');
      console.log('✅ Tokens stored in localStorage');
      console.log('Bearer token preview:', accessToken.substring(0, 50) + '...');
    };

    // Function to redirect to admin
    const redirectToAdmin = () => {
      setTimeout(() => {
        window.location.href = window.location.origin + '/admin';
      }, 1000);
    };

    processLogin();
  }, []);

  return (
    <div style={{textAlign: 'center', marginTop: 100, padding: 24}}>
      <h2>{status}</h2>
      {error && (
        <div style={{ color: '#b45309', marginTop: 16, padding: 16, background: '#fef3c7', borderRadius: 8, maxWidth: 600, margin: '16px auto', textAlign: 'left' }}>
          <p><strong>⚠️ Error:</strong> {error}</p>
          <p style={{ fontSize: '0.85rem', marginTop: 8 }}>
            If you see a CORS error, the Cognito App Client may have a client secret enabled. 
            Either disable client secret in Cognito, or use implicit flow (response_type=token).
          </p>
        </div>
      )}
      <p style={{marginTop: 20}}>
        <a href="/admin" style={{
          color: '#fff', 
          fontWeight: 600,
          background: '#6366f1',
          padding: '12px 24px',
          borderRadius: '8px',
          textDecoration: 'none',
          display: 'inline-block'
        }}>
          Go to Admin Panel
        </a>
      </p>
    </div>
  );
}

export default Callback;
